class HeroVideo {
  constructor() {
    this.initializeVideo();

    window.addEventListener('resize', this.initializeVideo);
  }

  initializeVideo = () => {
    if (document.documentElement.clientWidth < 768) {
      return;
    }

    const video = document.querySelector('.js-page-hero-video');

    if (!video) {
      return;
    }

    video.setAttribute('poster', video.dataset.poster);
    video.setAttribute('src', video.dataset.mp4);

    window.removeEventListener('resize', this.initializeVideo);
  };
}

export default HeroVideo;
